import { FolkSpreadsheet, FolkSpreadSheetCell, FolkSpreadsheetHeader } from '../folk-spreadsheet';
FolkSpreadsheet.define();
export { FolkSpreadsheet, FolkSpreadSheetCell, FolkSpreadsheetHeader };
//# sourceMappingURL=folk-spreadsheet.js.map